export default [

  {
    name: 'treeNormeDeg',
    type: 'gltfModel',
    path: 'models/tree/final7.gltf'
  },
  {
    name: 'video1First',
    type: 'texture',
    path: 'textures/tree/video-01-first.jpg'
  },
  {
    name: 'video1End',
    type: 'texture',
    path: 'textures/tree/lastframe3.jpg'
  },
  {
    name: 'video2First',
    type: 'texture',
    path: 'textures/tree/video-02-first.jpg'
  },
  {
    name: 'video2End',
    type: 'texture',
    path: 'textures/tree/video-02-end.jpg'
  },
  {
    name: 'matcap',
    type: 'texture',
    path: 'textures/matcap/matcap1.png'
  }
]
